'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ajax = require('../ajax');

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc 数据平台的接口 
 */
exports.default = {
    // 录入线索接口,
    advertisement: function advertisement(data) {
        return _ajax2.default.jsonp({
            url: '/api/v1/logApi/adv.jsonp',
            data: data
        });
    },

    // 种cookie
    addUserInfo2Cookie: function addUserInfo2Cookie(data) {
        return _ajax2.default.jsonp({
            url: '/api/userApi/addUserInfo2Cookie.jsonp',
            data: data
        });
    },

    // 上传经纬度
    latAndLonUpload: function latAndLonUpload(data) {
        return _ajax2.default.jsonp({
            url: '/api/logApi/latAndLonUpload.jsonp',
            data: data
        });
    },

    // 获取userTag
    getUserTag: function getUserTag(data) {
        return _ajax2.default.jsonp({
            url: '/api/userApi/getUserTag.jsonp',
            data: data
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-spm/dist/api/dataPlatform/index.js
// module id = 4z8/
// module chunks = 8